import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useAdminAuth } from 'contexts/AdminAuthContext';

export default function Navigation() {
  const { hasPermission } = useAdminAuth();

  const filteredItems = menuItem.items.map((item) => {
    if (item.type === 'group' && item.children) {
      return {
        ...item,
        children: item.children.filter((child) => {
          if (!child.permission) return true;
          return hasPermission(child.permission);
        })
      };
    }
    return item;
  }).filter((item) => {
    if (item.type === 'group') {
      return item.children && item.children.length > 0;
    }
    return true;
  });

  const navGroups = filteredItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" sx={{ color: 'error.main', textAlign: 'center' }}>
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
